import { Eyebrow } from "@/components/shared/Eyebrow";
import { Reveal } from "@/components/shared/Reveal";
import { motion } from "framer-motion";
import { Cpu, Layers, PencilRuler, ShieldCheck, Clock, Headset } from "lucide-react";

const ITEMS = [
  { n: "01", icon: Cpu, t: "Mühendislik Odaklı Yaklaşım", d: "Her projeye teknik derinlik ve mühendislik disipliniyle yaklaşıyoruz." },
  { n: "02", icon: Layers, t: "Anahtar Teslim Çözümler", d: "Keşiften devreye almaya kadar tüm süreci tek elden yönetiyoruz." },
  { n: "03", icon: PencilRuler, t: "Projelendirme & Uygulama", d: "Doğru tasarım ve titiz uygulama ile sürdürülebilir sonuçlar." },
  { n: "04", icon: ShieldCheck, t: "Güvenilir Teknik Altyapı", d: "Standartlara uygun, güvenli ve uzun ömürlü sistemler kuruyoruz." },
  { n: "05", icon: Clock, t: "Zamanında Teslim", d: "Planlı proje yönetimiyle taahhütlerimizi zamanında yerine getiriyoruz." },
  { n: "06", icon: Headset, t: "Satış Sonrası Teknik Destek", d: "Devreye alma sonrası planlı bakım ve satış sonrası teknik destek." },
];

export function WhyUs() {
  return (
    <section data-testid="why-section" className="relative bg-white py-24 md:py-28">
      <div className="mx-auto max-w-[1400px] px-5 md:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        {/* Left statement */}
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <Eyebrow className="mb-6">NEDEN SİSTEM?</Eyebrow>
            <Reveal>
              <h2 className="font-head font-extrabold text-ink tracking-tight text-4xl md:text-5xl leading-[1.05]">
                Güvenilir bir mühendislik ortağı.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-ink/60 leading-relaxed max-w-sm">
                Mühendislik yetkinliği, disiplinli süreç yönetimi ve satış sonrası destekle
                projelerinizde uçtan uca güven sağlıyoruz.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-8 h-px w-24 bg-cyan" />
            </Reveal>
          </div>
        </div>

        {/* Right numbered benefits */}
        <div className="lg:col-span-8">
          <div className="border-t border-ink/10">
            {ITEMS.map((it, i) => {
              const Icon = it.icon;
              return (
                <motion.div
                  key={it.n}
                  data-testid={`why-item-${i}`}
                  className="group grid grid-cols-[auto_1fr_auto] items-start gap-6 md:gap-10 py-7 md:py-8 border-b border-ink/10"
                  initial={{ opacity: 0, y: 18 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.5, delay: (i % 2) * 0.05 }}
                >
                  <span className="font-head font-bold text-lg md:text-xl tabular-nums text-ink/25 group-hover:text-cyan transition-colors duration-300 pt-1">
                    {it.n}
                  </span>
                  <div>
                    <h3 className="font-head font-bold text-ink text-xl md:text-2xl tracking-tight">{it.t}</h3>
                    <p className="text-ink/55 text-sm md:text-base mt-2 leading-relaxed max-w-xl">{it.d}</p>
                  </div>
                  <Icon className="w-6 h-6 text-ink/25 group-hover:text-cyan transition-colors duration-300 shrink-0 mt-1" strokeWidth={1.5} />
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
